<template>
  <div
    :class="{
      'sm:f--ml-2': singleColumn,
      'f-col-span-2': true,
      'f-pl-2.5': true,
    }"
  >
    <BaseCheckbox
      class="fapi-form-show-company-base-checkbox"
      :name="$id('show_full_form.name')"
      :disabled="disabled"
      v-model="value"
      @input="$emit('change', $event)"
      :class="{ 'sm:f-ml-32': singleColumn }"
    >
      {{ $t("basic_info.show_full_form.label") }}
    </BaseCheckbox>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseCheckbox from "@/components/Form/Basic/Inputs/BaseCheckbox.vue";

export default Vue.extend({
  name: "ShowFullForm",

  components: { BaseCheckbox },

  props: {
    forceFullInvoice: {
      type: Boolean,
      required: true,
    },
    singleColumn: {
      type: Boolean,
      default: false,
    },
  },

  data(): any {
    return {
      value: false,
      disabled: false,
    };
  },

  watch: {
    forceFullInvoice(value: boolean): void {
      let disabled = value;
      let checked = this.value;

      if (value) {
        checked = value;
      }

      this.value = checked;
      this.disabled = disabled;
      this.$emit("change", this.value);
    },
  },
});
</script>

<style></style>
